module.exports = __webpack_public_path__ + "img/coinapp-setting-step-three.2aef1055.png";